import type { ComponentProps } from 'react';

import type { FieldLayoutOptions } from './useFieldLayout';
import { FormTextarea } from './FormField';
import { useFieldLayout } from './useFieldLayout';

type TextareaFieldProps = Omit<ComponentProps<typeof FormTextarea>, 'label' | 'inputBackground'> &
  FieldLayoutOptions;

export const TextareaField = ({ label, hideLabel, ...fieldProps }: TextareaFieldProps) => {
  const field = useFieldLayout({ label, hideLabel });

  return (
    <FormTextarea
      label={field.label}
      aria-label={field.ariaLabel}
      inputBackground={field.inputBackground}
      {...fieldProps}
    />
  );
};
